// extracted by mini-css-extract-plugin
export default {"faqs":"styles_faqs__0jvmL","faqsInner":"styles_faqsInner__yWsSG","faqsContainer":"styles_faqsContainer__3C94z","qContainer":"styles_qContainer__4jCxv","table":"styles_table__BY2sC"};